import comp from "./VideoPlayer";
export default comp;
